import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-stats-card',
    templateUrl: './stats-card.component.html',
    styleUrls: ['./stats-card.component.scss'],
    standalone: true,
    imports: [NgClass, MatCardModule, MatIconModule]
})
export class StatsCardComponent {
    @Input() label: string = '';
    @Input() value: number | string = 0;
    @Input() icon: string = 'help';
    @Input() color: string = 'primary';
    @Input() customClass: string = '';
}
